<template>
  <div>
    <div class="page-wrapper">
      <div :class="isShow ? 'page-content-wrapper' : ''">
        <div class="shadow-btm">
          <div class="row">
            <div class="col-lg-6 col-sm-6 my-auto">
              <h4 class="mb-0 lg-bld">
                <a v-on:click="toggleMenu()" class="mr-3"
                  ><i class="bx bx-menu"></i
                ></a>
                <span>Married List</span>
              </h4>
            </div>
            <div class="col-lg-6 col-sm-6 text-last">
              <div class="mr-2">
                <a
                  style="font-size: 14px"
                  v-on:click="downloadBlankFormPdf()"
                  class="fill-btn btn-style cursor-pointer ml-3"
                  ><i class="fa fa-download"></i>&nbsp; Download Form</a
                >
              </div>
              <div class="mr-2">
                <a
                  style="font-size: 14px"
                  v-on:click="downloadPdf()"
                  class="fill-btn btn-style cursor-pointer"
                  ><i class="fa fa-download"></i>&nbsp; Download Excel</a
                >
              </div>
              <div>
                <a
                  style="font-size: 14px"
                  v-on:click="$router.push('/add-user')"
                  class="fill-btn btn-style cursor-pointer"
                  >+ Add User</a
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="page-content px-3"
          v-show="accessObject?.is_view == 1 || !isShowAccessDeniedMessage"
        >
          <div class="card-body py-0 px-0">
            <ul class="nav nav-pills col-12 row p-0 m-0">
              <!-- <li class="nav-item">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  style="cursor: pointer"
                  v-on:click="$router.push('/user')"
                >
                  <span>Leads Received </span>
                </a>
              </li> -->

              <li class="nav-item cursor-pointer mb-3 col-6 p-0 m-0">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  style="
                    cursor: pointer;
                    font-size: 14px;
                    text-align: center;
                    align-content: start;
                    background-color: white;
                  "
                  v-on:click="$router.push('/member-list/HIDE')"
                >
                  <span>Member List</span>
                </a>
              </li>
              <li class="nav-item cursor-pointer col-6 p-0 m-0">
                <a
                  class="nav-link"
                  data-toggle="tab"
                  style="
                    text-align: center;
                    align-content: end;
                    font-size: 14px;
                  "
                  :class="{ active: currentTab == 'ACCEPTED' }"
                  v-on:click="changeTab('ACCEPTED')"
                >
                  <span>Married List ({{ count }})</span>
                </a>
              </li>
            </ul>

            <div class="mb-0 radius-15 mt-2">
              <!-- card border -->

              <div class="mr-married-list-wrapper">
                <div class="">
                  <div class="row mb-2">
                    <div
                      class="col-lg-3 col-sm-3 form-group has-search my-auto"
                    >
                      <!-- <span class="bx bx-search form-control-feedback"></span> -->
                      <i
                        class="fa fa-search"
                        style="position: absolute; margin: 10px"
                        aria-hidden="true"
                      ></i>
                      <input
                        type="text"
                        style=""
                        class="form-control"
                        placeholder="Search "
                        v-model="searchObj.keyword"
                        v-on:keyup.enter="getList(0)"
                      />
                    </div>
                    <div class="col-lg-3 col-sm-3 form-group my-auto">
                      <a
                        style="cursor: pointer; font-size: 14px"
                        class="fill-btn btn-style cursor-pointer ml-3 mr-3"
                        v-on:click="getList(0)"
                        >Search</a
                      >
                      <a
                        style="cursor: pointer; font-size: 14px"
                        class="fill-btn btn-style cursor-pointer"
                        v-on:click="resetFilter()"
                        >Reset</a
                      >
                    </div>
                    <div class="col-lg-3 col-sm-3 form-group my-auto">
                      <div class="styled-select">
                        <select
                          v-on:change="getList(0)"
                          v-model="searchObj.gender"
                          name=""
                          aria-required="true"
                          aria-invalid="false"
                        >
                          <option value="" disabled selected="selected">
                            Select Gender
                          </option>
                          <option value="M">Male</option>
                          <option value="F">Female</option>
                        </select>
                        <span
                          class="bx bx-chevron-down"
                          style="top: 4px; right: 8px"
                        ></span>
                      </div>
                    </div>
                    <div class="col-lg-3 col-sm-3 form-group my-auto">
                      <div class="styled-select">
                        <select
                          v-on:change="getList(0)"
                          v-model="searchObj.membership_plan_id"
                          name=""
                          aria-required="true"
                          aria-invalid="false"
                        >
                          <option value="" disabled selected="selected">
                            Select Plan
                          </option>
                          <option value="FREE_MEMBER">Free Member</option>
                          <option
                            v-for="(data, index) in planList"
                            :key="index"
                            :value="data.uuid"
                          >
                            {{ data.name }}
                          </option>
                        </select>
                        <span
                          class="bx bx-chevron-down"
                          style="top: 4px; right: 8px"
                        ></span>
                      </div>
                    </div>
                    <div
                      class="col-lg-3 col-sm-3 form-group my-auto"
                      style="display: none"
                    >
                      <a
                        style="cursor: pointer; font-size: 14px"
                        class="fill-btn btn-style cursor-pointer ml-3 mr-3"
                        v-on:click="getList(0)"
                        >Search</a
                      >
                      <a
                        style="cursor: pointer; font-size: 14px"
                        class="fill-btn btn-style cursor-pointer"
                        v-on:click="resetFilter()"
                        >Reset</a
                      >
                    </div>
                  </div>
                </div>
                <div class="card mb-0 radius-15 custom-table">
                  <div class="card-body p-0 pb-4">
                    <div class="table-responsive">
                      <div class="dataTables_wrapper dt-bootstrap4">
                        <div class="row">
                          <span class="ml-4" style="color: black"
                            >Action -
                          </span>
                          <span class="ml-4" style="color: black">
                            E - Edit
                          </span>
                          <span class="ml-4" style="color: black"
                            >D - Delete</span
                          >
                          <span class="ml-4" style="color: black"
                            >P - Print
                          </span>
                          <span class="ml-4" style="color: black">
                            A - Activity
                          </span>

                          <span class="ml-4">
                            <a
                              style="background: rgb(236, 213, 219)"
                              class="fill-btn2"
                            ></a>
                            <span>&nbsp; - Married Through Nimbalkar</span>
                          </span>
                        </div>
                        <div class="tableFixHead">
                          <table
                            class="table table-striped table-bordered"
                            role="grid"
                            aria-describedby="example_info"
                          >
                            <thead>
                              <tr role="row">
                                <th>Actions</th>
                                <th
                                  class="sorting widID"
                                  id="id-registration_no"
                                  v-on:click="
                                    sorting(
                                      'registration_no',
                                      'id-registration_no'
                                    )
                                  "
                                >
                                  ID
                                </th>
                                <!-- <th style="">Photo</th> -->
                                <th
                                  class="sorting surwid"
                                  id="id-first_name"
                                  v-on:click="
                                    sorting('first_name', 'id-first_name')
                                  "
                                >
                                  <div>F Name</div>
                                </th>
                                <th
                                  class="sorting surwid"
                                  id="id-middle_name"
                                  v-on:click="
                                    sorting('middle_name', 'id-middle_name')
                                  "
                                >
                                  <div>M Name</div>
                                </th>
                                <th
                                  class="sorting surwid"
                                  id="id-last_name"
                                  v-on:click="
                                    sorting('last_name', 'id-last_name')
                                  "
                                >
                                  <div>Surname</div>
                                </th>
                                <th
                                  class="sorting"
                                  id="id-echo_status"
                                  v-on:click="
                                    sorting('echo_status', 'id-echo_status')
                                  "
                                >
                                  <div>ES</div>
                                </th>
                                <th
                                  class="sorting"
                                  id="id-dob"
                                  v-on:click="sorting('dob', 'id-dob')"
                                >
                                  <div>DOB</div>
                                </th>
                                <th
                                  class="sorting nativewidth"
                                  id="id-mobile"
                                  v-on:click="sorting('mobile', 'id-mobile')"
                                >
                                  <div>Contact Numb.</div>
                                </th>
                                <th
                                  class="sorting mamawid"
                                  id="id-name"
                                  v-on:click="
                                    sorting('district_name', 'id-name')
                                  "
                                >
                                  <div>Resi. Taluka</div>
                                </th>
                                <th class="unmaWidth">
                                  <div>Name Unmarried<br />Bro/Sis</div>
                                </th>
                                <th class="unmaWidth">
                                  <div>
                                    Birth Year of<br />Unmarried<br />Bro/Sis
                                  </div>
                                </th>
                                <th class="edunmaWidth">
                                  <div>Edu. of Unmarried<br />Bro/Sis</div>
                                </th>
                              </tr>
                            </thead>
                            <tbody v-show="!loader">
                              <tr
                                v-for="(data, index) in list"
                                :key="index"
                                :style="
                                  data.type == 'THROUGH_NIMBALKAR'
                                    ? 'background: #fae7ec'
                                    : ''
                                "
                              >
                                <td style="" class="">
                                  <a
                                    class="cursor-pointer"
                                    title="Delete"
                                    style="color: black; font-size: 10px"
                                    v-on:click="showDeletePopup(data)"
                                    >D</a
                                  >
                                  &nbsp;
                                  <a
                                    class="cursor-pointer"
                                    style="color: black; font-size: 10px"
                                    title="Print"
                                    v-on:click="downloadProfile(data)"
                                    >P</a
                                  >&nbsp;
                                  <a
                                    class="cursor-pointer"
                                    style="color: black; font-size: 10px"
                                    title="Activity"
                                    v-on:click="
                                      this.$router.push(
                                        '/user-activity/' + data.user_id
                                      )
                                    "
                                    >A</a
                                  >&nbsp;
                                  <a
                                    title="Edit"
                                    style="
                                      cursor: pointer;
                                      color: black;
                                      font-size: 10px;
                                    "
                                    v-on:click="
                                      $router.push('/edit-user/' + data.user_id)
                                    "
                                    >E</a
                                  >
                                </td>
                                <td>
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    "
                                  >
                                    {{
                                      data.registration_no
                                        ? data.registration_no
                                        : "-"
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    style="
                                      word-break: break-all !important;
                                      word-wrap: break-word;
                                    "
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    "
                                  >
                                    {{
                                      data.first_name ? data.first_name : "-"
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    style="
                                      word-break: break-all !important;
                                      word-wrap: break-word;
                                    "
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    "
                                  >
                                    {{
                                      data.middle_name ? data.middle_name : "-"
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    "
                                  >
                                    {{
                                      data.last_name ? data.last_name : "-"
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    "
                                  >
                                    {{ data.echo_status_name }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    "
                                  >
                                    {{
                                      $helperService.getFormatedDateNew(
                                        data.dob
                                      )
                                        ? $helperService.getFormatedDateNew(
                                            data.dob
                                          )
                                        : "-"
                                    }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    "
                                  >
                                    {{ data.mobile ? data.mobile : "-" }}</span
                                  >
                                </td>
                                <td>
                                  <span
                                    :style="
                                      data.color_code
                                        ? 'color:' + data.color_code
                                        : ''
                                    "
                                  >
                                    <!-- {{
                                      data.family_details &&
                                      data.family_details.taluka &&
                                      data.family_details.taluka.name
                                        ? data.family_details.taluka.name
                                        : "-"
                                    }} -->
                                    {{
                                      data.district_name
                                        ? data.district_name
                                        : "-"
                                    }}
                                  </span>
                                </td>
                                <td>
                                  <div
                                    v-for="(
                                      data2, index_2
                                    ) in data.family_members"
                                    :key="index_2"
                                  >
                                    <span
                                      v-if="data2.is_married == 'N'"
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      "
                                      >{{ data2.name }}</span
                                    >
                                  </div>
                                </td>
                                <td>
                                  <div
                                    v-for="(
                                      data2, index_2
                                    ) in data.family_members"
                                    :key="index_2"
                                  >
                                    <span
                                      v-if="data2.is_married == 'N'"
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      "
                                      >{{ data2.birth_year }}</span
                                    >
                                  </div>
                                </td>
                                <td>
                                  <div
                                    v-for="(
                                      data2, index_2
                                    ) in data.family_members"
                                    :key="index_2"
                                  >
                                    <span
                                      style="
                                        word-break: break-all !important;
                                        word-wrap: break-word;
                                      "
                                      v-if="data2.is_married == 'N'"
                                      :style="
                                        data.color_code
                                          ? 'color:' + data.color_code
                                          : ''
                                      "
                                      >{{
                                        data2.education ? data2.education : 0
                                      }}</span
                                    >
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="row mx-0 mb-4">
                            <div class="col-lg-12 text-center">
                              <div class="page-bottom-pagination text-right">
                                <Pagination
                                  @page-change="pageChange"
                                  @items-per-page-change="itemsPerPageChange"
                                  ref="listPagination"
                                />
                              </div>
                            </div>
                          </div>
                          <ErrorComponent
                            @retry="getList(0)"
                            ref="errorComponent"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="display: none">
                <div class="mb-0 radius-15">
                  <div class="card-body p-0 pb-4">coming soon</div>
                </div>
              </div>
              <div class="row mx-0 mb-4">
                <div class="col-lg-12 mt-5 text-center">
                  <div class="page-bottom-pagination text-right">
                    <div>
                      <!---->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <DeleteModal @remove="deleteRecord($event)" ref="deleteModal" />
</template>

<script>
import ErrorComponent from "@/components/ErrorComponent";
import Pagination from "@/components/Pagination";
import DeleteModal from "@/components/DeleteModal";
export default {
  name: "MarriedList",
  components: {
    ErrorComponent,
    DeleteModal,
    Pagination,
  },
  data() {
    return {
      accessObject: this.$helperService.getAccessLevel("Manage Users"),
      type: this.$route.params.type,
      loader: true,
      isShow: true,
      sort_id: "",
      order_by: "",
      sort_by: "",
      currentTab: "ACCEPTED",
      isShowAccessDeniedMessage: false,
      searchObj: {
        keyword: "",
        membership_plan_id: "",
        gender: "",
      },
      count: 0,
      offset: 0,
      list: [],
      planList: [],
    };
  },
  mounted() {
    localStorage.setItem("tab_type", "MARRIED");
    // if (!this.accessObject) {
    //   this.isShowAccessDeniedMessage = true;
    //   this.$router.push("/access-denied");
    //   return;
    // }
    this.getFilter();
    if (this.type) {
      this.toggleMenu();
    } else {
      this.toggleMenu();
      this.$helperService.showMenu("false");
    }
    this.getPlanList();
  },
  methods: {
    changeTab(tab) {
      this.currentTab = tab;
      this.searchObj.keyword = "";
    },
    downloadProfile(data) {
      var url = this.$api.getBaseUrl() + "/get/biodata?uuid=" + data.user_id;
      window.open(url);
    },
    toggleMenu() {
      this.isShow = !this.isShow;
      if (this.isShow == true) {
        this.$helperService.showMenu("true");
      } else {
        this.$helperService.showMenu("false");
      }
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getPlanList() {
      this.$api
        .getAPI({
          _action: "/plan/list",
        })
        .then((res) => {
          this.planList = res.list;
        })
        .catch(() => {});
    },
    getFilter() {
      this.searchObj = this.$shareService.getMapValue("married_lists_filter")
        ? this.$shareService.getMapValue("married_lists_filter")
        : {
            keyword: "",
            membership_plan_id: "",
            gender: "",
          };
      this.$helperService.sortingPrevent(
        this.searchObj.order_by,
        this.searchObj.sort_id
      );
      if (this.searchObj.offset || this.searchObj.offset == 0) {
        this.$refs.listPagination.setTotalCount(this.searchObj.count, 50);
        this.$refs.listPagination.setCurrentPage(this.searchObj.offset + 1);
        this.getList(this.searchObj.offset);
      } else {
        this.getList(0);
      }
    },
    getList(page, orderBy, sortBy) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      this.searchObj.offset = page;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      if (this.sort_id) {
        this.searchObj.sort_id = this.sort_id;
      }
      this.$api
        .getAPI({
          _action: "/married/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.count = res.count;
          this.offset = res.next_offset;
          this.searchObj.count = res.count;
          this.$shareService.setMapValue(
            "married_lists_filter",
            this.searchObj
          );
          this.accessObject =
            this.$helperService.getAccessLevel("Manage Users");
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(res, "No Married List Available");
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.sort_id = id;
      this.order_by = obj.order_by;
      this.sort_by = obj.sort_by;
      this.getList(0, obj.order_by, obj.sort_by);
    },
    resetFilter() {
      this.searchObj.keyword = "";
      this.searchObj.gender = "";
      this.searchObj.membership_plan_id = "";
      this.getList(0);
    },
    showDeletePopup(data) {
      this.$refs.deleteModal.showModal(
        "Delete Admin",
        "Are you sure you want to delete " + data.first_name,
        data
      );
    },
    downloadPdf() {
      var url = this.$api.getBaseUrl() + "/married/list/report";
      window.open(url);
    },
    downloadBlankFormPdf() {
      var url = this.$api.getBaseUrl() + "/blank/biodata";
      window.open(url);
    },
    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      this.$api
        .deleteAPI({
          _action: "/married/delete/" + detail.uuid,
        })
        .then((res) => {
          if (res) {
            this.$refs.deleteModal.closeModal();
            this.getList();
            this.$notify({
              type: "success",
              text: "Admin deleted successfully",
            });
          }
        })
        .catch(() => {
          this.$refs.deleteModal.removeLoader();
        });
    },
  },
};
</script>
